import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ruCommon from "./locales/ru/common.json";
import enCommon from "./locales/en/common.json";
import ruAuth from "./locales/ru/auth.json";
import enAuth from "./locales/en/auth.json";
import ruOnboarding from "./locales/ru/onboarding.json";
import enOnboarding from "./locales/en/onboarding.json";
import ruSchool from "./locales/ru/school.json";
import enSchool from "./locales/en/school.json";
import ruAthlete from "./locales/ru/athlete.json";
import enAthlete from "./locales/en/athlete.json";
import ruCoach from "./locales/ru/coach.json";
import enCoach from "./locales/en/coach.json";
import ruOrganizer from "./locales/ru/organizer.json";
import enOrganizer from "./locales/en/organizer.json";
import ruOrganizerComp from "./locales/ru/organizerComp.json";
import enOrganizerComp from "./locales/en/organizerComp.json";
import ruProtocolConstructor from "./locales/ru/protocolConstructor.json";
import enProtocolConstructor from "./locales/en/protocolConstructor.json";
import ruJudging from "./locales/ru/judging.json";
import enJudging from "./locales/en/judging.json";
import ruJudgeMisc from "./locales/ru/judgeMisc.json";
import enJudgeMisc from "./locales/en/judgeMisc.json";
import ruJudgeChief from "./locales/ru/judgeChief.json";
import enJudgeChief from "./locales/en/judgeChief.json";
import ruJudgeDifficulty from "./locales/ru/judgeDifficulty.json";
import enJudgeDifficulty from "./locales/en/judgeDifficulty.json";
import ruJudgeExecArt from "./locales/ru/judgeExecArt.json";
import enJudgeExecArt from "./locales/en/judgeExecArt.json";
import ruJudgeTech from "./locales/ru/judgeTech.json";
import enJudgeTech from "./locales/en/judgeTech.json";
import ruPages from "./locales/ru/pages.json";
import enPages from "./locales/en/pages.json";
import ruTournamentMgmt from "./locales/ru/tournamentMgmt.json";
import enTournamentMgmt from "./locales/en/tournamentMgmt.json";
import ruAdmin from "./locales/ru/admin.json";
import enAdmin from "./locales/en/admin.json";
import ruComponents from "./locales/ru/components.json";
import enComponents from "./locales/en/components.json";

// Поддерживаемые языки интерфейса. Язык проведения для ведущего (KZ/RU/EN)
// настраивается отдельно и НЕ связан с этим списком.
export const SUPPORTED_LOCALES = ["ru", "en"] as const;
export type AppLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: AppLocale = "ru";

export const LOCALE_LABELS: Record<AppLocale, string> = {
  ru: "Русский",
  en: "English",
};

// localStorage-ключ — единый источник для определения языка до загрузки профиля.
// После логина значение синхронизируется с user.locale (см. useLocale).
export const LOCALE_STORAGE_KEY = "judix-locale";

export const resources = {
  ru: { common: ruCommon, auth: ruAuth, onboarding: ruOnboarding, school: ruSchool, athlete: ruAthlete, coach: ruCoach, organizer: ruOrganizer, organizerComp: ruOrganizerComp, protocolConstructor: ruProtocolConstructor, judging: ruJudging, judgeMisc: ruJudgeMisc, judgeChief: ruJudgeChief, judgeDifficulty: ruJudgeDifficulty, judgeExecArt: ruJudgeExecArt, judgeTech: ruJudgeTech, pages: ruPages, tournamentMgmt: ruTournamentMgmt, admin: ruAdmin, components: ruComponents },
  en: { common: enCommon, auth: enAuth, onboarding: enOnboarding, school: enSchool, athlete: enAthlete, coach: enCoach, organizer: enOrganizer, organizerComp: enOrganizerComp, protocolConstructor: enProtocolConstructor, judging: enJudging, judgeMisc: enJudgeMisc, judgeChief: enJudgeChief, judgeDifficulty: enJudgeDifficulty, judgeExecArt: enJudgeExecArt, judgeTech: enJudgeTech, pages: enPages, tournamentMgmt: enTournamentMgmt, admin: enAdmin, components: enComponents },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    nonExplicitSupportedLngs: true, // "en-US" → "en"
    defaultNS: "common",
    ns: ["common", "auth", "onboarding", "school", "athlete", "coach", "organizer", "organizerComp", "protocolConstructor", "judging", "judgeMisc", "judgeChief", "judgeDifficulty", "judgeExecArt", "judgeTech", "pages", "tournamentMgmt", "admin", "components"],
    interpolation: {
      escapeValue: false, // React сам экранирует
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    // Помогает замечать незакрытые ключи в dev (видно в консоли).
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: import.meta.env.DEV
      ? (_lng, ns, key) => {
          console.warn(`[i18n] missing key: ${ns}:${key}`);
        }
      : undefined,
  });

export default i18n;
